import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEN from "assets/locales/en/translation.json";
import translationIT from "assets/locales/it/translation.json";

// the translations
const resources = {
  en: {
    translation: translationEN,
  },
  it: {
    translation: translationIT,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: "it",
    lng: "it",

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
